import actions from "./actions";

const initState = {
  token: "",
  adminToken: "",
  adminTokenDetails: {},
  companies: [],
  companiesDetails: [],
  selectedLanguage: localStorage.getItem("selectedLanguage") || "bg",
  showChooseDestinationText: true,
  openMenuDrawer: false,
  showEuroPrice: true,
};

export default function mainReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_AUTH_TOKEN_SUCCESS:
      return {
        ...state,
        token: action.token,
      };

    case actions.GET_ADMIN_TOKEN_SUCCESS:
      return {
        ...state,
        adminToken: action.adminToken,
        adminTokenDetails: action.adminTokenDetails,
      };

    case actions.GET_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: action.companies,
      };

    case actions.GET_COMPANIES_DETAILS_SUCCESS:
      return {
        ...state,
        companiesDetails: action.companiesDetails,
      };

    case actions.SET_SELECTED_LANGUAGE:
      return {
        ...state,
        selectedLanguage: action.value,
      };

    case actions.SET_SHOW_CHOOSE_DESTINATION_TEXT:
      return {
        ...state,
        showChooseDestinationText: action.value,
      };

    case actions.SET_OPEN_MENU_DRAWER:
      return {
        ...state,
        openMenuDrawer: action.value,
      };

    default:
      return state;
  }
}
